import { groupBy } from 'lodash';
import { ThemedStyleFn } from '~src/hooks/useStyles';
import { DbSecurityGroup, DbFolder } from '~src/types/db';
import { SEC_GROUP_PRIORITY } from '~src/types/enums';
import { secGroupSectionsConfig } from '~src/utils/securityGroupsConfig';

export const tabStyleFn: ThemedStyleFn = (theme) => ({
  folderIcon: {
    color: theme.colors.yellow,
    fontSize: 18,
    marginTop: -7,
  },
  folderIconContainer: {
    minWidth: 20,
    marginRight: 7,
  },
});

/** `DbSecurityGroup['color']` map;
 * Should use this for tags color if present
 */

export interface SecGroupOption {
  /** id */
  key: number;
  value: number;
  label: string;
}

export interface SecGroupSection {
  key: string;
  label: string;
  intlId: string;
  color: string;
  options: SecGroupOption[];
}

/** Map DbSecurityGroup[] to Select.OptGroup > Select.Option list  */
export const mapSecGroupsToSections = (secGroups: DbSecurityGroup[] = []) => {
  const groupedByPriority = groupBy(secGroups, 'priority');

  const sections: SecGroupSection[] = Object.entries(groupedByPriority).map(
    ([key, groups]) => {
      return {
        key: `sec-group-section-${key}`,
        label: `Section ${key}`,
        intlId:
          secGroupSectionsConfig[key]?.intlId ||
          secGroupSectionsConfig[SEC_GROUP_PRIORITY.CUSTOM].intlId,
        color: secGroupSectionsConfig[key]?.color,
        options: groups.map(mapSecGroupToOption),
      };
    }
  );

  /** 
   * The higher value, the higher in the dropdown it should be.
    Eg.
    (2) - internal Perm grouping SG are second to bottom.
    (1) - WG_SG are in the bottom. 
  */
  return sections.reverse();
};

/** Map DbSecurityGroup[] to Select.Option value  */
export const mapSecGroupToOption = (
  secGroup: DbSecurityGroup
): SecGroupOption => ({
  key: secGroup.id,
  value: secGroup.id,
  label: `${secGroup.description} (${secGroup.name})`,
});

export interface TableEntry {
  /** String(folder.id) */
  key: string;
  parentId: string;
  title: string;
  children?: TableEntry[];
  dbFolder: DbFolder;
}

const dbFolderToTreeObj = (dbFolder: DbFolder): TableEntry => {
  const { id, name, parent_id } = dbFolder;

  return {
    key: String(id),
    parentId: String(parent_id),
    title: name || 'Unknown',
    children: [],
    dbFolder,
  };
};
